import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import { approvalReducer } from 'components/features/Approval'
import { oAuthApi } from 'components/features/Auth/api'
import oAuthReducer from 'components/features/Auth/api/oAuthSlice'
import { documentApi } from 'components/features/Documents/api/documentsApi'
import replaceDocumentReducer from 'components/features/Documents/api/replaceDocumentSlice'
import {
  filesApi,
  metaApi,
  scopesApi,
  uiReducer,
} from 'components/features/Other/api'
import { permissionsReducer } from 'components/features/Other/api/permissionsSlice'
import { practicesApi } from 'components/features/Practices/api'
import { currentPracticeReducer } from 'components/features/Practices/api/currentPracticeSlice'
import { searchApi } from 'components/features/Search/api'
import { uploadApi } from 'components/features/Upload/api/docUploadApi'
import { docUploadReducer } from 'components/features/Upload/api/docUploadSlice/docUploadSlice'
import { userApi } from 'components/features/User/api'

import { announcementsApi } from '../components/features/Dashboard/api/announcementsApi'
import { currentDocumentsReducer } from '../components/features/Documents/api/currentDocumentsSlice'
import { editorReducer } from '../components/features/Documents/api/editorSlice'
import { metadataApi } from '../components/features/Documents/api/metadataApi'
import { wopiApi } from '../components/features/Documents/api/wopiApi'
import { currentMaterialsReducer } from '../components/features/Materials/api/currentMaterialSlice'
import { materialsApi } from '../components/features/Materials/api/materialsApi'
import { minimalPracticeReducer } from '../components/features/Practices/api/minimalPracticeSlice'
import { practiceReducer } from '../components/features/Practices/api/practiceSlice'
import { materialUploadApi } from '../components/features/Upload/api/materialUploadApi'
import { materialUploadReducer } from '../components/features/Upload/api/materialUploadSlice/materialUploadSlice'

export const rootReducer = combineReducers({
  oauth: oAuthReducer,
  ui: uiReducer,
  docsUpload: docUploadReducer,
  materialsUpload: materialUploadReducer,
  practice: practiceReducer,
  minimalPractice: minimalPracticeReducer,
  currentPractice: currentPracticeReducer,
  approval: approvalReducer,
  replaceDocument: replaceDocumentReducer,
  permissions: permissionsReducer,
  currentDocuments: currentDocumentsReducer,
  currentMaterials: currentMaterialsReducer,
  editor: editorReducer,

  /**
   * API Reducers
   */
  [oAuthApi.reducerPath]: oAuthApi.reducer,
  [metaApi.reducerPath]: metaApi.reducer,
  [documentApi.reducerPath]: documentApi.reducer,
  [practicesApi.reducerPath]: practicesApi.reducer,
  [scopesApi.reducerPath]: scopesApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [searchApi.reducerPath]: searchApi.reducer,
  [filesApi.reducerPath]: filesApi.reducer,
  [uploadApi.reducerPath]: uploadApi.reducer,
  [materialUploadApi.reducerPath]: materialUploadApi.reducer,
  [announcementsApi.reducerPath]: announcementsApi.reducer,
  [materialsApi.reducerPath]: materialsApi.reducer,
  [metadataApi.reducerPath]: metadataApi.reducer,
  [wopiApi.reducerPath]: wopiApi.reducer,
})

export const apiMiddleware = [
  oAuthApi.middleware,
  metaApi.middleware,
  documentApi.middleware,
  materialsApi.middleware,
  practicesApi.middleware,
  scopesApi.middleware,
  userApi.middleware,
  searchApi.middleware,
  filesApi.middleware,
  announcementsApi.middleware,
  uploadApi.middleware,
  materialUploadApi.middleware,
  metadataApi.middleware,
  wopiApi.middleware,
]

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(apiMiddleware),
  devTools: process.env.NODE_ENV !== 'production',
})

export default store

setupListeners(store.dispatch)
